/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationPricingsDailyBenefitMutation from '../graphql/mutations/SaveSimulationPricingsDailyBenefitMutation.js';

export const useSaveSimulationPricingsDailyBenefitMutation = () => {
  return useCommitMutation(SaveSimulationPricingsDailyBenefitMutation, {
    dataProp: 'saveSimulationPricingsDailyBenefit_M_simulation_pricings_daily_benefit'
  });
};

export default useSaveSimulationPricingsDailyBenefitMutation;
